import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BookingItem } from '@fry/booking/lib/booking-items';


@Component({
    selector: 'eas-editor-booking-item-export-dialog',
    templateUrl: './editor-booking-item-export-dialog.component.html',
    styleUrls: ['./editor-booking-item-export-dialog.component.css'],
    standalone: false
})
export class EditorBookingItemExportDialogComponent implements OnInit {
  item: BookingItem;

  constructor(
    private dialogRef: MatDialogRef<EditorBookingItemExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      bookingItem: BookingItem
    }
  ) {

  }

  ngOnInit() {
    this.item = this.data.bookingItem;
  }

  bookingItemToText(): string {
    return JSON.stringify(this.item.doc);
  }

  onClose() {
    this.dialogRef.close();
  }
}
